<div
	class="loading"
	*ngIf="loading">
	<div>
		<i class="fa fa-circle-notch fa-spin fa-2x fa-fw"></i>
		Attendere, il calcolo può impiegare fino a 60s.
	</div>
</div>
<div
	(click)="load()"
	class="mb-2"
	*ngIf="!loading">
	<i class="feather icon-refresh-cw f-20"></i>

</div>
<div
	class="mb-2"
	*ngIf="!loading && !summary">
	Rendicontazione non disponibile
</div>
<div
	*ngIf="!loading && summary?.typecosts"
	class="table-responsive">

	<h6>Costi per tipologia</h6>
	<table class="table table-striped thead-dark table-hover table-sm">
		<thead>
			<tr>
				<td class="text-left align-middle">Costi ammissibili</td>
				<td class="text-center align-middle">Importo €</td>
				<td class="text-center align-middle">
					% rispetto al
					<br>
					totale dei costi ammissibili
				</td>
				<td class="text-center align-middle">Ricerca industriale</td>
				<td class="text-center align-middle">Sviluppo sperimentale</td>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let row of summary.typecosts">
				<td class="text-left align-middle">{{row.cost}}</td>
				<td class="text-right align-middle">{{row.amount | elcurrency:"EUR"}}</td>
				<td class="text-right align-middle">{{row.percentage | number:'1.2-2'}} %</td>
				<td class="text-right align-middle">{{row.research | elcurrency:"EUR"}}</td>
				<td class="text-right align-middle">{{row.development | elcurrency:"EUR"}}</td>

			</tr>
		</tbody>
	</table>
</div>

<div
	*ngIf="!loading && summary?.partnercosts"
	class="table-responsive">
	<h6>Costi per partecipante</h6>
	<table class="table table-striped thead-dark table-hover table-sm">
		<thead>
			<tr>
				<td class="text-left align-middle">Riepilogo costi</td>
				<td class="text-center align-middle">Costi ammissibili</td>
				<td class="text-center align-middle">
					% rispetto al
					<br>
					totale dei costi
					<br>
					ammissibili
				</td>
				<td class="text-center align-middle">
					Dimensione azienda
					<br>
					(PI - MI - GI)
				</td>
				<td class="text-center align-middle">
					Costi di
					<br>
					Ricerca Industriale
				</td>
				<td class="text-center align-middle">
					Costi di
					<br>
					Sviluppo Sperimentale
				</td>
				<td class="text-center align-middle">
					Intensità
					<br>
					di aiuto Ric. Ind.le %
				</td>
				<td class="text-center align-middle">
					Intensità
					<br>
					di aiuto Svil. Sper. %
				</td>
				<td class="text-center align-middle">
					Contributo
					<br>
					richiesto per
					<br>
					Ric. Ind.le
				</td>
				<td class="text-center align-middle">
					Contributo
					<br>
					richiesto per
					<br>
					Svil. Sper.
				</td>
				<td class="text-center align-middle">
					Contributo
					<br>
					richiesto
				</td>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let row of summary.partnercosts">
				<td class="text-left align-middle">{{row.name}}</td>
				<td class="text-right align-middle">{{row.amount | elcurrency:"EUR"}}</td>
				<td class="text-right align-middle">{{row.percentage | number:'1.2-2' }}%</td>
				<td class="text-center align-middle">{{row.companysize}}</td>
				<td class="text-right align-middle">{{row.research | elcurrency:"EUR"}}</td>
				<td class="text-right align-middle">{{row.development | elcurrency:"EUR"}}</td>
				<td class="text-right align-middle">{{row.devfundingpct}}%</td>
				<td class="text-right align-middle">{{row.resfundingpct}}%</td>
				<td class="text-right align-middle">
					{{row.devfundingrequired | elcurrency:"EUR"}}
				</td>
				<td class="text-right align-middle">
					{{row.resfundingrequired | elcurrency:"EUR"}}
				</td>
				<td class="text-right align-middle">{{row.totalfunding | elcurrency:"EUR"}}</td>

			</tr>
		</tbody>
	</table>
</div>

<div
	*ngIf="!loading && summary?.yearlycosts?.length"
	class="table-responsive">
	<h6>Costi per annualità</h6>
	<table class="table table-striped thead-dark table-hover table-sm">
		<thead>
			<tr>
				<td class="text-left">Costi per annualità</td>
				<ng-template
					ngFor
					let-cell
					[ngForOf]="summary?.yearlycosts[0].cells">
					<td>{{cell.year}}</td>
				</ng-template>

			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let row of summary?.yearlycosts">
				<td class="text-left">{{row.name}}</td>
				<ng-template
					ngFor
					let-cell
					[ngForOf]="row.cells">
					<td>{{cell.amount | elcurrency:"EUR"}}</td>
				</ng-template>

			</tr>
		</tbody>
	</table>
</div>
